<template>
  <q-select
    ref="select"
    multiple
    use-chips
    popup-content-class="multi-select-options"
    :model-value="modelValue"
    :enterkeyhint="dialogBehaviour ? 'done' : undefined"
    v-bind="$attrs"
    @keydown.enter="onEnterKey"
    @input-value="onSearchInput"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template v-if="!$slots.option" #option="scope">
      <q-select-color-item
        v-bind="scope.itemProps"
        type="checkbox"
        :label="scope.label"
      />
    </template>

    <!-- Phone picker dialog: its top field is a search box, so label it as one.
         Which span shows is decided in styleoverrides.scss -->
    <template v-if="dialogBehaviour" #label>
      <span class="select-page-label">{{ $attrs.label }}</span>
      <span class="select-dialog-label">Search options</span>
    </template>

    <template v-if="dialogBehaviour" #append>
      <q-btn
        v-show="searchTerm"
        class="select-dialog-clear"
        icon="cancel"
        color="grey-6"
        flat
        round
        dense
        @click.stop="clearSearch"
      />
      <q-btn
        class="select-dialog-done"
        label="Done"
        color="primary"
        flat
        dense
        @click.stop="closePopup"
      />
    </template>

    <template v-for="name in Object.keys($slots)" #[name]="scope">
      <slot :name="name" v-bind="scope || {}" />
    </template>
  </q-select>
</template>

<script>
import selectDialog from 'src/helpers/selectDialog'

/**
 * Multi-select over a static option list.
 *
 * Wraps QSelect (all props, events and slots pass through) so every pick-from-a-list
 * multi-select behaves the same: chips in the field and checkbox rows in the list.
 * On touch devices the picker opens as a dialog whose top field is a clone of this
 * one; `multi-select-options` lets styleoverrides.scss drop the chips from that clone,
 * since the checked rows already show the selection, and the selectDialog mixin gives
 * it Done / clear-search buttons. Selects where chips are the value being edited
 * (free-text tags, email addresses) stay on a plain QSelect.
 *
 * SLOTS: any QSelect slot; `option` overrides the checkbox row.
 */
export default {
  mixins: [selectDialog],
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue']
}
</script>
